import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import { defValueConvenio, IPesquisaConvenio } from "../../types/api/geral/convenios";

export default function SelectConvenio({
    value,
    onChange,
    required = false,
    error = false,
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    const inputLabel = value ? `${value.codigo ?? ''}${value.nome ? ` - ${value.nome}` : ''}` : ""

    return (
        <>
            <TextField
                {...{ required, error }}
                label={`Convênio`}
                variant="outlined"
                fullWidth
                onClick={() => setOpenModal(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: { readOnly: true }
                }}
                value={inputLabel}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose }}
                        title="Selecionar convenio"
                        queryPath="/pesquisar-convenios"
                        defaultValue={value || defValueConvenio}
                        getItemKey={(item) => item.codigo}
                        getItemLabel={(item) => `${item.codigo} - ${item.nome}`}
                        onChange={(value) => {
                            onChange(value as IPesquisaConvenio)
                            handleClose()
                        }}
                    />
                </Dialog>

            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: IPesquisaConvenio
    onChange: (arg: IPesquisaConvenio | null) => void
    required?: boolean
    error?: boolean
}